<template>
  <div>

    <div class="settings-option-buttons">
      <button
        class="firstOption"
        @click="settingsOption = false"
        v-bind:class="{ 'active':  !settingsOption }"
      >
        Company Details
      </button>

      <button
        class="secondOption"
        @click="settingsOption = true"
        v-bind:class="{ 'active':  settingsOption }"
      >
        Security
      </button>
    </div>

    <!-- Loader Component -->
    <Loader
      v-if="loading"
    />

    <div class="settings-views" v-if="!loading">

      <div class="company-details-option" v-if="!settingsOption">
        <div class="container-left">

          <!-- Image Uploader Component -->
          <image-upload
            v-bind:title="'Company'"
          />

          <div class="input-holder">
            <div class="header">
              <h3>Company Name</h3>
            </div>
            <input
              type="text"
              name="companyName"
              v-model="companyName"
              @change="validateText"
            />
            <p v-if="error.companyNameError" class="error">Please enter a valid input</p>
          </div>

          <div class="input-holder">
            <div class="header">
              <h3>Company Email</h3>
            </div>
            <input
              type="text"
              name="companyEmail"
              placeholder="email@company.com"
              v-model="companyEmail"
              @change="validateText"
            />
            <p v-if="error.companyEmailError" class="error">Please enter a valid input</p>
          </div>

          <div class="input-holder">
            <div class="header">
              <h3>Company Address</h3>
            </div>
            <input
              type="text"
              name="companyAddress"
              placeholder="Address Line 1"
              v-model="companyAddress"
              @change="validateText"
            />
            <p v-if="error.companyAddressError">Please enter a valid input</p>
          </div>

          <div class="input-holder">
            <div class="header">
              <h3>Company Phone</h3>
            </div>
            <input
              type="text"
              name="companyPhone"
              placeholder="e.g. +14131854138 or 4131854138"
              v-model="companyPhone"
              @change="validateText"
            />
            <p v-if="error.companyPhoneError" class="error">Please enter a valid input</p>
          </div>

          <div class="input-holder">
            <div class="header">
              <h3>Industry</h3>
            </div>
            <select
            name="industry"
            v-model="companyIndustry"
            @change="validateText"
          >
            <option
              v-for="(item, index) in industryList"
              :key="index"
              :value="item.value"
            >
              {{ item.title }}
            </option>
          </select>
          <p v-if="error.industryError" class="error">Please enter a valid input</p>
          </div>
        </div>


        <div class="container-right">
          <div class="input-holder">
            <div class="header">
              <h3>Company Contact Person</h3>
            </div>
            <input
              type="text"
              name="companyContactPerson"
              placeholder="e.g. Adewale Olawale"
              v-model="companyContactPerson"
              @change="validateText"
            />
            <p v-if="error.companyContactPersonError" class="error">Please enter a valid input</p>
          </div>

          <div class="input-holder">
            <div class="header">
              <h3>Company Contact Person Phone</h3>
            </div>
            <input
              type="text"
              name="companyContactPersonPhone"
              placeholder="e.g. +14131854138 or 4131854138"
              v-model="companyContactPersonPhone"
              @change="validateText"
            />
            <p v-if="error.companyContactPersonPhoneError" class="error">Please enter a valid input</p>
          </div>

          <div class="input-holder">
              <div class="header">
                <h3>Company Contact Person Email Address</h3>
              </div>
              <input
                type="text"
                name="companyContactPersonEmail"
                :value="companyContactPersonEmail"
                @change="validateText"
                disabled
              />
              <p v-if="error.companyContactPersonEmailError" class="error">Please enter a valid input</p>
            </div>

          <div class="input-holder">
            <div class="header">
              <h3>Website URL</h3>
            </div>
            <input
              type="text"
              name="websiteUrl"
              placeholder="https://"
              v-model="userData.websiteUrl"
              @change="validateText"
            />
            <p v-if="error.websiteUrlError" class="error">Please enter a valid input</p>
          </div>


          <div class="state-and-city-holder">
            <div class="input-holder">
              <div class="header">
                <h3>State/Province</h3>
              </div>
              <input
                type="text"
                name="state"
                placeholder="e.g. Ontario"
                v-model="userData.state"
                @change="validateText"
              />
              <p v-if="error.stateError" class="error">Please enter a valid input</p>
            </div>

            <div class="input-holder">
              <div class="header">
                <h3>City</h3>
              </div>
              <input
                type="text"
                name="city"
                placeholder="e.g. Toronto"
                v-model="userData.city"
                @change="validateText"
              />
              <p v-if="error.cityError" class="error">Please enter a valid input</p>
            </div>
          </div>

          <div class="input-holder">
            <h3>Number of Employees</h3>
            <div class="employees">

              <div
                v-for="number in employeeStrength"
                v-bind:key="number.name"
                v-bind:class="{ 'active-employee-number': formData.employees === number.range }"
                name="employees"
                @click="validateText({target: {value: number.range, name: number.name}})"
              >
                <button>
                  <p>{{number.range}}</p>
                  <p>Employees</p>
                </button>
              </div>

            </div>
          </div>

          <div class="buttons">
            <button class="cancel-btn">Cancel</button>
            <button @click="handleProfileUpdate()" class="update-btn">Save</button>
          </div>
        </div>
      </div>


      <div class="security-option" v-if="settingsOption">
        <div class="wrapper">

          <!-- Password Change Component -->
          <password-change
            v-on:closePasswordSettings="closePasswordSettings()"
            v-on:logout="$emit('logout')"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ImageUpload from '../components/body/ImageUpload.vue';
import Loader from '../components/body/Loader.vue';
import PasswordChange from '../components/body/PasswordChange.vue';

export default {
  name: 'ProfileSettings',
  components: {
    ImageUpload,
    PasswordChange,
    Loader
  },
  data() {
    return {
      userData: {},
      settingsOption: false,
      loading: false,
      formData: {
        companyName: null,
        companyEmail: null,
        companyAddress: null,
        companyPhone: null,
        industry: null,
        companyContactPerson: null,
        companyContactPersonPhone: null,
        companyContactPersonEmail: null,
        websiteUrl: null,
        state: null,
        city: null,
        employees: this.$store.state.userData.businessSize ?
        this.$store.state.userData.businessSize
        : this.$store.state.userData.employeeStrength,
      },
      error: {
        companyNameError: false,
        companyEmailError: false,
        companyAddressError: false,
        companyPhoneError: false,
        industryError: false,
        companyContactPersonError: false,
        companyContactPersonPhoneError: false,
        companyContactPersonEmailError: false,
        websiteUrlError: false,
        stateError: false,
        cityError: false,
        employeesError: false,
      },
      industryList: [
        { title: 'Technology', value: 'Technology' },
        { title: 'Education', value: 'Education' },
        { title: 'Product Design', value: 'Product Design' },
        { title: 'Product Management', value: 'Product Management' },
        { title: 'Project Management', value: 'Project Management' },
        { title: 'Administration', value: 'Administration' },
        { title: 'Operations', value: 'Operations' },
        { title: 'Sales', value: 'Sales' },
        { title: 'Marketing', value: 'Marketing' },
        { title: 'Customer Service', value: 'Customer Service' },
        { title: 'Human Resources', value: 'Human Resources' },
        { title: 'Creative & Design', value: 'Creative and Design' },
        { title: 'Media & Communications', value: 'Media and Communications' },
        { title: 'Health & Wellness', value: 'Health and Wellness' },
        { title: 'Hospitality & Tourism', value: 'Hospitality and Tourism' },
        { title: 'Arts & Entertainment', value: 'Arts and Entertainment' },
        { title: 'Science & Research', value: 'Science and Research' },
        { title: 'Agriculture', value: 'Agriculture' },
        { title: 'Finance', value: 'Finance' },
        { title: 'Supply Chain', value: 'Supply Chain' },
        { title: 'Engineering', value: 'Engineering' },
        { title: 'Building & Construction', value: 'Building and Construction' },
        {
          title: 'Logistics & Transportation',
          value: 'Logistics and Transportation',
        },
        { title: 'Legal', value: 'Legal' },
        { title: 'Energy & Utilities', value: 'Energy and Utilities' },
        { title: 'Telecommunications', value: 'Telecommunications' },
        {
          title: 'Petroleum & Petrochemicals',
          value: 'Petroleum and Petrochemicals',
        },
        {
          title: 'Furniture & Interior Design',
          value: 'Furniture and Interior Design',
        },
        { title: 'Manufacturing', value: 'Manufacturing' },
        { title: 'Healthcare', value: 'Healthcare' },
        { title: 'Others', value: 'Others' },
      ],
      employeeStrength: [
        {
          name: 'a',
          range: '1 - 25'
        },
        {
          name: 'b',
          range: '26 - 50'
        },
        {
          name: 'c',
          range: '51 - 100'
        },
        {
          name: 'd',
          range: '101 - 250'
        },
        {
          name: 'e',
          range: '251 - 500'
        },
        {
          name: 'f',
          range: '500+'
        },
      ]
    };
  },
  computed: {
    numberOfEmployees: {
      get () {
        return this.userData.businessSize
        ? this.userData.businessSize
        : this.userData.employeeStrength;
      },
      set (val) {
        this.formData.employees = val;
      }
    },
    companyName: {
      get () {
        return this.userData.companyName
        ? this.userData.companyName
        : this.userData.agencyName;
      },
      set (val) {
        this.formData.companyName = val;
      }
    },
    companyIndustry: {
      get () {
        return this.userData.businessType
        ? this.userData.businessType
        : this.userData.industry;
      },
      set (val) {
        this.formData.industry = val;
      }
    },
    companyPhone: {
      get () {
        return this.userData.businessRepPhone
        ? this.userData.businessRepPhone
        : this.userData.agencyPhone;
      },
      set (val) {
        this.formData.companyPhone = val;
      }
    },
    companyEmail: {
      get () {
        return this.userData.companyEmail
        ? this.userData.companyEmail
        : this.userData.agencyEmail;
      },
      set (val) {
        this.formData.companyEmail = val;
      }
    },
    companyAddress: {
      get () {
        return this.userData.businessAddress
        ? this.userData.businessAddress
        : this.userData.agencyAddress;
      },
      set (val) {
        this.formData.companyAddress = val;
      }
    },
    companyContactPerson: {
      get () {
        return `${this.userData.firstName} ${this.userData.lastName}`;
        // return this.userData.businessRepName
        // ? this.userData.businessRepName
        // : `${this.userData.firstName} ${this.userData.lastName}`;
      },
      set (val) {
        this.formData.companyContactPerson = val;
      }
    },
    companyContactPersonPhone: {
      get () {
        return this.userData.phone;
      },
      set (val) {
        this.formData.companyContactPersonPhone = val;
      }
    },
    companyContactPersonEmail: {
      get () {
        return this.userData.emailAddress;
      },
      set (val) {
        this.formData.companyContactPersonEmail = val;
      }
    },
  },
  methods: {
    getUserData () {
      this.userData = this.$store.state.userData;
      return this.userData;
    },
    handleProfileUpdate(){
      if(
        this.error.companyNameError ||
        this.error.companyEmailError ||
        this.error.companyAddressError ||
        this.error.companyPhoneError ||
        this.error.industryError ||
        this.error.companyContactPersonError ||
        this.error.companyContactPersonPhoneError ||
        this.error.companyContactPersonEmailError ||
        this.error.websiteUrlError ||
        this.error.stateError ||
        this.error.cityError
      ) {
        null;
      } else {
        this.loading = true;
        this.$store
        .dispatch('updateProfile', [
          // send the formData, selected image, userType
          //  and userId to the store action
          this.formData,
          this.selectedImage,
          this.userData.userType,
          this.userData.id
        ])
        .then((res) => {
          if ( res && res.response) {
            this.loading = false;
            this.$toastr.success(res.response, 'Success');
            setInterval(()=>{
              this.$router.go();
            }, 1000);
            // this.$router.go();
          } else if (res && res.error) {
            this.$toastr.error(
              res.error
              ? res.error.data.error
              : res.error.errorMessage,
              'Failed'
            );
          }
        });
      }
    },
    validateText(e) {
      let fieldName = e.target.name;
      let fieldValue = e.target.value;
      let phoneFormat;
      let format;
      let emailFormat;

      switch (fieldName) {
        case 'companyName':
          this.$store.state.userData.userType === 'admin' ? // This line will always set the company name to the admin company value in the .env file.
          this.formData.companyName = process.env.VUE_APP_ADMIN_COMPANY_NAME
          :this.formData.companyName = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.companyNameError = true;
          } else {
            this.error.companyNameError = false;
          }
          break;

        case 'companyEmail':
          this.formData.companyEmail = fieldValue;
          emailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (fieldValue.match(emailFormat)) {
            this.error.companyEmailError = false;
          } else {
            this.error.companyEmailError = true;
          }
          break;

        case 'companyAddress':
          this.formData.companyAddress = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.companyAddressError = true;
          } else {
            this.error.companyAddressError = false;
          }
          break;

        case 'companyPhone':
          // phoneFormat = /^\d+$/;
          phoneFormat = /^\+?[0-9][0-9]{7,14}$/;
          this.formData.companyPhone = fieldValue;
          // if (fieldValue.match(phoneFormat) && (fieldValue.length > 8 && fieldValue.length < 15) ) {
          if (fieldValue.match(phoneFormat)) {
            this.error.companyPhoneError = false;
          } else {
            this.error.companyPhoneError = true;
          }
          break;

        case 'industry':
          this.formData.industry = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.industryError = true;
          } else {
            this.error.industryError = false;
          }
          break;

        case 'companyContactPerson':
          this.formData.companyContactPerson = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.companyContactPersonError = true;
          } else {
            this.error.companyContactPersonError = false;
          }
          break;

        case 'companyContactPersonPhone':
          this.formData.companyContactPersonPhone = fieldValue;
          format = /^\d+$/;
          if (fieldValue.match(format) && (fieldValue.length > 8 && fieldValue.length < 12) ) {
            this.error.companyContactPersonPhoneError = false;
          } else {
            this.error.companyContactPersonPhoneError = true;
          }
          break;

        case 'companyContactPersonEmail':
          this.formData.companyContactPersonEmail = fieldValue;
          emailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (fieldValue.match(emailFormat)) {
            this.error.companyContactPersonEmailError = false;
          } else {
            this.error.companyContactPersonEmailError = true;
          }
          break;

        case 'websiteUrl':
          this.formData.websiteUrl = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.websiteUrlError = true;
          } else {
            this.error.websiteUrlError = false;
          }
          break;

        case 'state':
          this.formData.state = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.stateError = true;
          } else {
            this.error.stateError = false;
          }
          break;

        case 'city':
          this.formData.city = fieldValue;
          if (fieldValue && fieldValue.trim().length < 3) {
            this.error.cityError = true;
          } else {
            this.error.cityError = false;
          }
          break;

        // EmployeeStrength
        case 'a':
        case 'b':
        case 'c':
        case 'd':
        case 'e':
        case 'f':
          this.formData.employees = fieldValue;
          break;

      }
    },
    closePasswordSettings() {
      this.settingsOption = false;
    }
  },
  beforeMount() {
    this.getUserData();
  },
};
</script>

<style scoped>
  .settings-option-buttons button{
    min-width: 240px;
    background: #F1F1F1;
    border-radius: 5px;
    font-family: 'montserrat';
    font-style: normal;
    font-weight: 500;
    outline: none;
    font-size: 1.15rem;
    line-height: 24.38px;
    color: hsl(0, 7%, 48%);
    padding: 15px 30px;
  }
  .settings-option-buttons .firstOption{
    margin-right: 70px;
  }
  .active {
    background: #025fa0 !important;
    color: white !important;
  }
  .company-details-option {
    background: var(--white);
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    border-radius: 15px;
    margin-top: 40px;
    padding: 40px;
  }
  .company-details-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .container-left, .container-right {
    width: 45%;
  }
  h3 {
    font-family: 'montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    line-height: 21.94px;
    color: var(--colorSecondary);
  }
  p {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #5B5B5B;
    margin-top: 17px;
  }
  input, select, .employees > div {
    width: 100%;
    height: 50px;
    box-shadow: 0px 0px 4px 2px rgba(39, 31, 31, 0.15);
    border-radius: 5px;
    outline: none;
    padding: 10px;
    font-family: 'montserrat';
    font-size: 1rem;
    color: rgba(51, 52, 54, 0.7);
    line-height: 1.25rem;
    -webkit-appearance: auto;
    color: rgba(51, 52, 54, 0.7);
    margin-top: 13px;
  }
  .input-holder {
    margin-bottom: 35px;
  }
  .input-holder .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .input-holder p.error {
    font-size: 14px;
    color: tomato;
  }
  .state-and-city-holder {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .state-and-city-holder > div,
  .employees > div {
    width: 48%;
  }
  .employees > div:hover{
    background: #025fa0 !important;
  }
  .employees {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    cursor: pointer;
  }
  .employees > div {
    height: 147px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .employees > div button :nth-child(1) {
    font-style: normal;
    font-weight: 600;
    outline: none;
    font-size: 1rem;
    line-height: 29px;
    color: var(--colorSecondary);
  }
  .employees > div button :nth-child(2) {
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 22px;
    outline: none;
    color: #636363;
  }
  .active-employee-number {
    color: var(--white) !important;
    background: #025fa0 !important;
  }
  .active-employee-number > button p {
    color: var(--white) !important;
  }
  .employees > div:hover button p {
    color: #ffffff !important;
}
  .buttons {
    display: flex;
    justify-content: right;
    margin: 60px 0 40px 0;
  }
  .security-buttons {
    display: flex;
    margin-top: 40px;
  }
  .buttons button, .security-buttons button {
    border-radius: 5px;
    padding: 15px 50px;
    font-weight: 800;
    outline: none;
    min-width: 180px;
  }
  .buttons .update-btn, .security-buttons .update-btn {
    background: var(--colorPrimary);
    box-shadow: 0px 9px 29px rgba(26, 107, 158, 0.1);
    color: var(--white);
    outline: none;
  }
  .buttons .cancel-btn, .security-buttons .cancel-btn {
    color: #252525;
    box-sizing: border-box;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
    outline: none;
    margin-right: 40px;
  }
  /* .security-option .wrapper {
    padding: 60px;
    width: 50%;
  } */
  /* Responsiveness */
  @media only screen and (min-width: 1400px) {
    /* .security-option .wrapper {
      width: 55%;
    } */
  }
  @media only screen and (max-width: 1399px) {
    /* .security-option .wrapper {
      width: 70%;
    } */
  }
  @media only screen and (max-width: 1080px) {
    .company-details-option{
      flex-direction: column;
    }
    .container-left, .container-right {
      width: 100%;
    }
    /* .security-option .wrapper {
      padding: 60px 20px;
      width: 100%;
    } */
  }
  @media only screen and (max-width: 565px) {
    .settings-option-buttons button {
      width: 100%;
    }
    .buttons button, .security-buttons button {
      width: 160px;
      margin: 10px 0 !important;
    }
    .buttons {
      margin: 0 auto;
      flex-direction: column;
      align-items: center;
    }
  }
  @media only screen and (max-width: 480px) {
    .company-details-option, .security-option {
      padding: 40px 20px;
    }
  }
  @media only screen and (max-width: 370px) {
    .employees {
      flex-direction: column;
    }
    .state-and-city-holder {
      flex-direction: column;
    }
    .state-and-city-holder > div, .employees > div {
      width: 100%;
    }
  }
</style>
